// ANCHOR Extensions
import { IMAGES } from './fileExtensions/images';

// ANCHOR Interface
interface IUrl {
  url: string;
  queryParams: string | null;
  hasQueryParams: boolean;
}

interface IFile {
  file: string;
  name: string;
  extension: string;
  isImage: boolean;
}

interface IResult {
  url: IUrl;
  file: IFile;
}

/**
 * Returns the original url and file properties such as the file name,
 *  extension, combination of both, whether it is an image, or does the
 *  url contains a query param.
 *
 * @param {string} url Url given
 *
 */
export const parseFileFromUrl = (url: string): IResult => {
  const hasQueryParams = url.lastIndexOf('?') !== -1;
  const queryParams = url.substring(url.lastIndexOf('?') + 1);

  const file = url.substring(
    url.lastIndexOf('/') + 1,
    hasQueryParams
      ? url.lastIndexOf('?')
      : undefined,
  );

  const name = file.substring(0, file.lastIndexOf('.'));
  const extension = file.substring(file.lastIndexOf('.'));
  const isImage = IMAGES.includes(extension);

  return {
    url: {
      url,
      queryParams: hasQueryParams ? queryParams : null,
      hasQueryParams,
    },
    file: {
      file,
      name,
      extension,
      isImage,
    },
  };
};
